import {
    Component,
    Inject,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IAttachment } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging/logging.service';

@Component({
    selector: 'ef-expense-receipt-view-presenter',
    templateUrl: './expense-receipt-view-presenter.component.html',
    styleUrls: ['./expense-receipt-view-presenter.component.scss'],
    standalone: false
})
export class ExpenseReceiptViewPresenterComponent implements OnChanges {
    @Input() public attachment: IAttachment;
    isImage(attachment: IAttachment): boolean {
        return attachment && attachment.Filemimetype.startsWith('image');
    }
    constructor(
        private sanitizer: DomSanitizer,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.attachment && changes.attachment.currentValue) {
            const attachment = changes.attachment.currentValue;
            if (attachment.File) {
                this.log.verbose({
                    type: 'ExpenseReceiptViewPresenterComponent.ngOnChanges',
                    attachment: changes.attachment.currentValue
                });
                this.attachment.SafeResource =
                    this.sanitizer.bypassSecurityTrustResourceUrl(
                        this.attachment.File
                    );
                if (!this.isImage(attachment)) {
                    const downloadLink = document.createElement('a');
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    // var json = JSON.stringify(data),
                    const blob = this.dataURItoBlob(attachment);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = attachment.Filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            }
        }
    }
    dataURItoBlob(attachment: IAttachment) {
        const dataURI = attachment.File.substring(attachment.File.indexOf(',') + 1);
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], {
            type: attachment.Filemimetype
        });
        return blob;
    }
}
